// @flow
import { DateUtil } from "../../../utils/datetime/DateTimeUtil";

import type { IConstraintModel } from "../../types";

/**
 */
class DateTimeDateFormatConstraint implements IConstraintModel {
  _format: string;
  _formatLabel: string;

  /**
   */
  constructor(format: string, formatLabel: string) {
    this._format = format;
    this._formatLabel = formatLabel;
  }

  /**
   */
  get id(): string {
    return "Constraint.DateFormat.InvalidFormat";
  }

  /**
   */
  get format(): string {
    return this._format;
  }

  /**
   */
  get formatLabel(): string {
    return this._formatLabel;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Date must be entered in the format ${format}"; // NOSONAR
  }

  /**
   */
  get parameters(): { format: string } {
    return { format: this.formatLabel };
  }

  /**
   */
  validate(value: string): boolean {
    if (!value) {
      return false;
    }

    return DateUtil.hasFormat(value, this.format);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default DateTimeDateFormatConstraint;
